// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609291223/js/" + chunkId + "." + {"44":"0cad20cc","225":"35f520e1","481":"c968b8a1","486":"766866bb","770":"b3f6b1ad"}[chunkId] + ".0.2139828285762876.chunk.js";
};